import { requiredSIPForTarget, requiredLumpsumForTarget } from "../../engine/calculations";

const config = {
  key: "req-sip-or-lumpsum",
  title: "SIP / Lumpsum Required for Target FV",
  category: "Target-Based",
  description: "Compare two ways to reach the same future value target: a monthly SIP, or a lumpsum today.",
  fields: [
    { key: "targetFV", label: "Target future value", type: "currency", default: 50_00_000, min: 1000, max: 100_00_00_000 },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "years", label: "Years to target", type: "number", default: 10, min: 1, max: 40 },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Amount", colorVar: "--gold" }],
  },
  compute(values) {
    const targetFV = Number(values.targetFV) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;

    const requiredSIP = requiredSIPForTarget(targetFV, annualRate, years * 12);
    const requiredLumpsum = requiredLumpsumForTarget(targetFV, annualRate, years);

    return {
      headline: { label: "Required Monthly SIP", value: requiredSIP },
      extraHeadlines: [{ label: "Or, Required Lumpsum Today", value: requiredLumpsum }],
      breakdown: [{ label: "Target future value", value: targetFV }],
      series: [
        { name: "Monthly SIP (x12/yr)", amount: requiredSIP * 12 },
        { name: "Lumpsum Today", amount: requiredLumpsum },
      ],
    };
  },
};

export default config;
